import React, { useRef } from "react";
import Swal from "sweetalert2";
import { domain } from "../../../Urls/Services/Api_urls";
import { handleKeyPress } from "../../Apoyo/handleKeyPress";
import Dashboard from "../../Dasboard/Dashboard";
import MapRender2 from "../../CoberturaFTTH/Maps2";
import Swalgeneral from "../../../Landing/General/Swalgeneral";

import { ArrowLeftCircled } from "iconoir-react";



export const PolygonEdit = (props) => {
  const data = props.data;
  const dataRender = props.dataRender;
  const cdoRef = useRef(data.cdo || "");
  const socialStratumRef = useRef(data.social_stratum || "");
  const cityRef = useRef(data.city || "");
  const polygonRef = useRef(data.coordenadasPoligono || []);
  const url = `${domain}/polygonsftth/${data.id}/`;

  const validatePolygon = (polygon) => {
    if (!Array.isArray(polygon) || polygon.length === 0) {
      return false;
    }
  
    return polygon.every(coord => 
      Array.isArray(coord) && coord.length === 2 &&
      typeof coord[0] === 'number' && typeof coord[1] === 'number'
    );
  };

  const PoligonEdit = async (e) => {
    e.preventDefault();

    let polygon;
    try {
      polygon = polygonRef.current ? JSON.parse(polygonRef.current.value) : undefined;
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "El formato del polígono es inválido.",
        icon: "error",
        showConfirmButton: true,
      });
      return;
    }

    if (!validatePolygon(polygon)) {
      Swal.fire({
        title: "Error!",
        text: "El polígono tiene un formato inválido.",
        icon: "error",
        showConfirmButton: true,
      });
      return;
    }

    const fields = [
      { key: "cdo", ref: cdoRef },
      { key: "polygon", value: polygon },
      { key: "social_stratum", ref: socialStratumRef },
      { key: "city", ref: cityRef },
    ];
    console.log(fields);

    const credentials = fields.reduce((acc, field) => {
      if (field.ref) {
        acc[field.key] = field.ref.current.value || undefined;
      } else if (field.value !== undefined) {
        acc[field.key] = field.value;
      }
      return acc;
    }, {});

    console.log(credentials);
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${props.token}`,
        },
        body: JSON.stringify(credentials),
      });

      const respuesta = await response.json();
      if (response.status === 200) {
        Swal.fire({
          title: "Polígono guardado",
          html: "Polígono guardado de manera satisfactoria",
          icon: "success",
          showCancelButton: false,
          allowOutsideClick: false,
          confirmButtonColor: "#3085d6",
          showConfirmButton: true,
          confirmButtonText: "ok",
        }).then(() => {
          window.location.href = "/Polygon";
        });
      } else {
        Swalgeneral("Error", "error", "text", JSON.stringify(respuesta));
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        footer: "Fallo en el servidor",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const handlePolygonEdit = (newPolygons) => {
    polygonRef.current.value = JSON.stringify(newPolygons[0].polygon);
  };

  return (
    <>
      <Dashboard
        MInicio={""}
        Msolicitudes={""}
        Mempaquetar={""}
        Mservicios={""}
        Mcompra={""}
        Mcunyompra={""}
        Mcpotenciales={""}
        Madminportal={"active"}
        Mcampaña={""}
      >
      <section className="home-section">
        
       
        <div style={{ height: 40 }} />
        <div className="row">
          <h3 style={{ padding: "1rem" }}>Editar poligono</h3>
          <form>
            <input
             disabled
              className="col-md-12"
              type="text"
              placeholder={data.cdo}
              ref={cdoRef}
              defaultValue={data.cdo}
              style={{ marginBottom: "1rem", height: "6rem", width: "80%" }}
            />
           

            <select
            disabled
              className="select"
              ref={cityRef}
              defaultValue={data.city}
              style={{ marginBottom: "1rem", width: "80%", height: "6rem" }}
            >
              <option value={data.city}>{data.city}</option>
              <option value="76001">Cali</option>
              <option value="76364">Jamundi</option>
              <option value="76892">Yumbo</option>
              <option value="76130">Candelaria</option>
              <option value="19573">Puerto tejada</option>
              <option value="76520">Palmira</option>
            </select>

            {/* <textarea
              onKeyPress={handleKeyPress}
              className="col-md-12"
              type="text"
              placeholder={
                "[[-76.558024857999953, 3.36232314800003], [-76.558211888999949, 3.3622669800000722] ...]"
              }
              ref={polygonRef}
              defaultValue={JSON.stringify(data.coordenadasPoligono)}
              rows="10"
              cols="30"
              style={{ marginBottom: "1rem", height: "18rem", width: "80%" }}
            /> */}
            <div style={{ height: 0 }} />
            <div style={{ display: "flex", justifyContent: "center", marginBottom: '2rem' }}>
              <MapRender2
                data={dataRender}
                display={""}
                width={"80%"}
                height={"28rem"}
                zoom={18}
                onPolygonEdit={handlePolygonEdit}
              />
            </div>
            <div className="flex justify-center items-center">
            <a
              className="bg-colorprimary p-2 text-white rounded-lg flex gap-2 justify-center items-center w-52"
            
               href="/Polygon"
            >
              <ArrowLeftCircled/>
              Atras
            </a>

            </div>
          </form>
          <div style={{ height: 20 }} />
        </div>
      </section>
      </Dashboard>
    </>
  );
};
